export default __webpack_public_path__ + "static/media/endocrine.6a1f06b5.jpg";